import { BookletCount, BookletPaper, BookletSide } from '~/tenants/bre/performable/print/booklets/BreBookletsConfig';

type CountMap = Record<BookletCount, string>;

type PaperMap = Record<BookletPaper, CountMap>;

type SideMap = Record<BookletSide, Partial<PaperMap>>;

export const BreBookletsRate: SideMap = {
  8: {
    low_gloss: {
      50: '490',
      100: '635',
      150: '815',
      200: '970',
    },
    heavy_gloss: {
      50: '510',
      100: '645',
      150: '825',
      200: '980',
    }
  },
  12: {
    low_gloss: {
      50: '670',
      100: '805',
      150: '1060',
      200: '1285',
    }
  },
  16: {
    low_gloss: {
      50: '710',
      100: '985',
      150: '1305',
      200: '1640',
    }
  },
  20: {
    low_gloss: {
      50: '885',
      100: '1230',
      150: '1630',
      200: '1995',
    }
  },
  24: {
    low_gloss: {
      50: '1020',
      100: '1435',
      150: '1900',
      200: '2335',
    }
  },
  28: {
    low_gloss: {
      50: '1150',
      100: '1635',
      150: '2170',
      200: '2560',
    }
  },
  32: {
    low_gloss: {
      50: '1285',
      100: '1830',
      150: '2440',
      200: '2890',
    }
  },
};

export const BreBookletsPay: SideMap = {
  8: {
    low_gloss: {
      50: '425',
      100: '550',
      150: '705',
      200: '840',
    },
    heavy_gloss: {
      50: '440',
      100: '560',
      150: '715',
      200: '850',
    }
  },
  12: {
    low_gloss: {
      50: '570',
      100: '700',
      150: '920',
      200: '1115',
    }
  },
  16: {
    low_gloss: {
      50: '615',
      100: '855',
      150: '1135',
      200: '1395',
    }
  },
  20: {
    low_gloss: {
      50: '770',
      100: '1070',
      150: '1415',
      200: '1735',
    }
  },
  24: {
    low_gloss: {
      50: '885',
      100: '1245',
      150: '1650',
      200: '2030',
    }
  },
  28: {
    low_gloss: {
      50: '1000',
      100: '1420',
      150: '1885',
      200: '2225',
    }
  },
  32: {
    low_gloss: {
      50: '1115',
      100: '1590',
      150: '2120',
      200: '2510',
    }
  },
};
